import {getTranslationKey} from '@hconnect/common/utils/translation.utils'
import {Moment} from 'moment-timezone'

import type {KpiData, MonthlyTrendsKpisDto} from '../types'

// Re-export formatKpiValue from common utils
export {formatKpiValue} from '@hconnect/common/utils'

const enhanceKpiLabelWithEquipmentName = (label: string, equipmentName?: string | null): string => {
  return equipmentName ? `${label} - ${equipmentName}` : label
}

type FormatKpiLabelParams = Pick<KpiData, 'label' | 'name' | 'equipmentName'>

export const formatKpiLabel = (
  {name, label, equipmentName}: FormatKpiLabelParams,
  t: (key: string) => string,
  tPrefix?: string
): string => {
  if (name !== undefined) {
    return enhanceKpiLabelWithEquipmentName(name, equipmentName)
  }
  return enhanceKpiLabelWithEquipmentName(
    t(getTranslationKey(`kpis.label.${label}`, tPrefix)),
    equipmentName
  )
}

export const getKpiTypeKey = (
  kpiType: string | undefined,
  kpiName: string,
  equipmentName?: string | null
): string => {
  return equipmentName ? `${kpiType ?? kpiName}-${equipmentName}` : kpiType ?? kpiName
}

export const getHasDenodoDataForDate = (
  kpisMonthlyTrends: MonthlyTrendsKpisDto[] | undefined,
  date: Moment
): boolean => {
  const year = date.year()
  // months are 0-indexed in moment.js so we need to add 1 to match API indexing
  const month = date.month() + 1

  return !!kpisMonthlyTrends?.find((kpi) =>
    kpi.kpis.some(({yearMonth}) => yearMonth.year === year && yearMonth.month === month)
  )
}
